import { useAuth } from '@hb/react'
import { USER_ROLES, UserRoleItem } from '@hb/shared'
import { useDocument } from '../../../backend/db/hooks/useDocument'

export const useMyRoleItem = () => {
  const authUser = useAuth(state => state.authUser)
  const uid = authUser?.uid
  return useDocument<UserRoleItem>(USER_ROLES, uid)
}
